import domReady from '@roots/sage/client/dom-ready';
import Splide from '@splidejs/splide';

import $ from 'jquery';
import 'masonry-layout';

// Import Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Vue3SocialSharingPlugin from 'vue3-social-sharing';
import { VueMasonryPlugin } from 'vue-masonry';


import Toast, { PluginOptions, POSITION } from 'vue-toastification';



/* VUE | START */
import ActivityIndicator from './vue/components/ActivityIndicator';
import LoginWidget from './vue/components/LoginWidget';
import RegisterWidget from './vue/components/RegisterWidget';
import RatingWidget from './vue/components/RatingWidget';
//import PasswordRecoveryWidget from './vue/components/PasswordRecoveryWidget';

import CardsList from './vue/components/CardsList';
import ContentCard from './vue/components/ContentCard';
import ContentActions from './vue/components/ContentActions';
import ContentIcon from './vue/components/ContentIcon';
import LikeButton from './vue/components/LikeButton';
import VideoPlayer from './vue/components/VideoPlayer';
import VideoButton from './vue/components/VideoButton';
import ActivityList from './vue/components/ActivityList';
import CommentsModal from './vue/components/CommentsModal';
import CommentsSection from './vue/components/CommentsSection';
import ReviewsSection from './vue/components/ReviewsSection';
import CommentField from './vue/components/CommentField';
import Bookmarks from './vue/components/Bookmarks';
import ImageUploadButton from './vue/components/user_pages/ImageUploadButton';
import UserStoryEditor from './vue/components/user_pages/UserStoryEditor';
import InlineEditor from './vue/components/user_pages/InlineEditor';
import EditProfileButton from './vue/components/user_pages/EditProfileButton';
import EditSchoolButton from './vue/components/user_pages/EditSchoolButton';
import EditInterestsButton from './vue/components/user_pages/EditInterestsButton';
import AvatarEditor from './vue/components/user_pages/AvatarEditor';
import MyStories from './vue/components/user_pages/MyStories';
import MyCommunitiButton from './vue/components/user_pages/MyCommunitiButton';
import UserWallPosts from './vue/components/UserWallPosts';
import UserWallSlider from './vue/components/UserWallSlider';
import UserNotifications from './vue/components/UserNotifications';
import StoryTeaser from './vue/components/StoryTeaser';
import EmbedVideoButton from './vue/components/VideoButton';
import FormSupport from './vue/components/FormSupport';
import KitOrderWidget from './vue/components/KitOrderWidget';
import FollowButton from './vue/components/FollowButton';
import TagCloud from './vue/components/TagCloud';
import TagList from './vue/components/TagList';
import OverlayContainer from './vue/components/OverlayContainer';



import SideUserWidgetButton from './vue/components/SideUserWidgetButton';

import { useMainStore } from './vue/stores/main';
import ApiService from './vue/services/api';

const app = createApp();

const pinia = createPinia();
app.use(pinia);

app.use(Toast, {
  position: POSITION.BOTTOM_LEFT,
});
app.use(Vue3SocialSharingPlugin);
app.use(VueMasonryPlugin);



app.component('ActivityIndicator', ActivityIndicator);
app.component('RegisterWidget', RegisterWidget);
app.component('LoginWidget', LoginWidget);
app.component('RatingWidget', RatingWidget);

app.component('ContentCard', ContentCard);
app.component('ContentActions', ContentActions);
app.component('ContentIcon', ContentIcon);
app.component('CardsList', CardsList);
app.component('CommentsModal', CommentsModal);
app.component('CommentField', CommentField);

app.component('LikeButton', LikeButton);
app.component('VideoPlayer', VideoPlayer);
app.component('VideoButton', VideoButton);
app.component('EmbedVideoButton', EmbedVideoButton);
app.component('AvatarEditor', AvatarEditor);

app.component('SideUserWidgetButton', SideUserWidgetButton);
app.component('CommentsSection', CommentsSection);
app.component('ReviewsSection', ReviewsSection);
app.component('Bookmarks', Bookmarks);
app.component('ImageUploadButton', ImageUploadButton);
app.component('UserStoryEditor', UserStoryEditor);
app.component('InlineEditor', InlineEditor);
app.component('EditProfileButton', EditProfileButton);
app.component('EditSchoolButton', EditSchoolButton);
app.component('EditInterestsButton', EditInterestsButton);
app.component('MyStories', MyStories);
app.component('UserWallPosts', UserWallPosts);
app.component('UserWallSlider', UserWallSlider);
app.component('UserNotifications', UserNotifications);
app.component('StoryTeaser', StoryTeaser);

app.component('ActivityList', ActivityList);
app.component('FormSupport', FormSupport);

app.component('KitOrderWidget', KitOrderWidget);
app.component('FollowButton', FollowButton);
app.component('MyCommunitiButton', MyCommunitiButton);
app.component('TagCloud', TagCloud);
app.component('TagList', TagList);
app.component('OverlayContainer', OverlayContainer);

app.mount('#tiwi-vue-app');

var store = useMainStore();

var api = new ApiService();
api.client.get('app/handshake').then((response) => {
  if (response.data.user)
    store.setUser(response.data.user);

  if (response.data.config)
    store.setConfig(response.data.config);

  if (response.data.activity)
    store.setUserActivity(response.data.activity);

  if (response.data.statistics)
    store.setStatistics(response.data.statistics);

  store.setAppReady(true);
});

/* VUE | END */

/**
 * Application entrypoint
 */
domReady(async () => {
  const mounted_sliders = [];

  // Mount all splide sliders

  window.enablePageJs = function (selector) {

    if (!selector)
      selector = '';

    const splides = document.querySelectorAll(selector + ' .splide');

    if (splides.length) {
      for (var i = 0; i < splides.length; i++) {
        mounted_sliders[splides[i].id] = new Splide(splides[i]).mount();
      }

    }
  }

  window.enablePageJs();


  $('[data-splide-goto]').on('click', function () {
    mounted_sliders[$(this).data('splide-id')].go($(this).data('splide-goto'));
  });

  $('.slider-link[href="#playVideo"]').on('click', function () {
    app._instance?.refs.videoPlayer.openModal();
  });

  if ($('#site-nav').hasClass('has-cover')) {
    $(window).on('scroll', function () {
      if ($(this).scrollTop() < 80) {
        $('.site-nav').removeClass('has-logo-dark');
        $('.site-nav').addClass('header-alt-light has-logo-light');
      } else {
        $('.site-nav').removeClass('header-alt-light has-logo-light');
        $('.site-nav').addClass('has-logo-dark');
      }
    });
  }

  $('.fade-in').each(function (i) {
    const obj = this;
    $(obj).css({ 'opacity': '0' });

    $(window).on('scroll', function () {
      const obj_btm = $(obj).parent().offset().top + $(obj).outerHeight() + 300;
      const wind_btn = $(window).scrollTop() + $(window).height();

      /* If the object is completely visible in the window, fade it it */
      if (wind_btn > obj_btm) {
        if ($(obj).css('opacity') == 0)
          $(obj).animate({ opacity: '1' }, 350);
      } else {
        if ($(obj).css('opacity') == 1)
          $(obj).animate({ opacity: '0' }, 350);
      }
    });
  });
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
